import { render } from "./HomeSlide.vue?vue&type=template&id=2a06a558"
import script from "./HomeSlide.vue?vue&type=script&lang=js"
export * from "./HomeSlide.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__